module.exports = __webpack_public_path__ + "b9a5f6587e8f6d1e74f9c870979c7b78.png";